import enumBase from './EnumBase';

export default class PlanIntervalText extends enumBase {
  static values = [1, 3, 6, 12];

  static getByInterval(interval) {
    return this.values.includes(interval)
      ? `pages.planDetails.planInterval.${interval}`
      : 'pages.planDetails.planInterval.fallback';
  }
}
